import { render } from "./sidebar-dropdown.vue?vue&type=template&id=6d628e04"
import script from "./sidebar-dropdown.vue?vue&type=script&lang=js"
export * from "./sidebar-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/layouts/partials/sidebar-dropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d628e04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d628e04', __exports__)) {
    console.log('reload')
    api.reload('6d628e04', __exports__)
  }
  
  module.hot.accept("./sidebar-dropdown.vue?vue&type=template&id=6d628e04", () => {
    console.log('re-render')
    api.rerender('6d628e04', render)
  })

}


export default __exports__